import React from 'react'


export default function Heroo(){

    return(

        <div className="section" style={{ backgroundColor: "#7352FF", height: "50vh",width:"100%",position:"absolute"  }}>
            <p className="text-center  fs-1" style={{color:"white",fontFamily:"Sombra",}}>Start your day with the goodness of Yoga</p> 
        </div>
    )
}